






























import { Component, Mixins } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../base/components/system/mixins";

@Component({
  components: {
  }
})
export default class EditableFormatSummaryTreeNameEditDialog extends Mixins(DialogMixin) {
  result: boolean = false;
  isFolder: boolean = true;
  isAppend: boolean = true;
  beforeText: string = "";
  modifiedText: string = "";

  $refs!: {
    input: HTMLInputElement
  };

  get isEnteredText(): boolean {
    return this.beforeText !== this.modifiedText;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  async show(isFolder: boolean, isAppend: boolean, text: string): Promise<void> {
    return this.showModal(async () => {
      this.result = false;
      this.isFolder = isFolder;
      this.isAppend = isAppend;
      this.beforeText = text;
      this.modifiedText = text;
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
      await this.waitHidden();
    });
  }

  confirm(): void {
    if (this.isEnteredText) {
      this.result = true;
    }
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
